import { render } from "./GameCards.vue?vue&type=template&id=288bb758&scoped=true"
import script from "./GameCards.vue?vue&type=script&lang=js"
export * from "./GameCards.vue?vue&type=script&lang=js"

import "./GameCards.vue?vue&type=style&index=0&id=288bb758&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-288bb758"

export default script